<template>
    <b-modal :title="modalAssetName"
             v-model="modalShow"
             size="lg"
             @hidden="modalAsset = null"
             centered
             scrollable>
        <div class="d-flex justify-content-center">
            <div v-if="isVideo">
                <video-player
                        :thumb-url="modalAssetUrl"
                        :url="modalAsset.media_thumb_url"/>
            </div>

            <div v-else>
                <b-img :src="modalAssetUrl" fluid/>
            </div>

        </div>

        <template v-slot:modal-header>
            <div class="d-flex align-items-center w-100">
                <h5 class="m-0 flex-grow-1">{{ modalAssetName }}</h5>
                <b-button class="mr-2" variant="light" @click="modalPrevAsset" v-if="assets.length > 1">
                    <i class="fa fas fa-chevron-left"/>
                </b-button>
                <b-button class="mr-2" variant="light" @click="modalNextAsset" v-if="assets.length > 1">
                    <i class="fa fas fa-chevron-right"/>
                </b-button>
                <b-button variant="light" @click="modalShow = false" v-if="assets.length > 1">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>

        <template v-slot:modal-footer>
            <b-row class="w-100">
                <b-col cols="auto">
                    <div class="text-label">Categories</div>
                    <b-badge variant="primary" class="mr-1 font-weight-medium rounded"
                             v-for="categoryName in modalAssetCategories">
                        {{ categoryName }}
                    </b-badge>
                </b-col>
                <b-col>
                    <div class="text-label">Tags</div>
                    <b-badge variant="primary" class="mr-1 font-weight-medium rounded"
                             v-for="tagName in modalAssetTags">
                        {{ tagName }}
                    </b-badge>
                </b-col>
                <b-col v-if="modalAsset.notes">
                    <div class="text-label">Notes</div>
                    <div>{{ modalAsset.notes }}</div>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
  import generalMixins from "../../mixins/GeneralMixins";
  import VideoPlayer from "./VideoPlayer";

  export default {
    props: ['assets', 'tagCategoryPriority'],

    data: function () {
      return {
        modalShow: false,
        modalAsset: null,
      }
    },

    watch: {
      modalAsset: function (asset) {
        this.modalShow = !!asset
      }
    },

    mounted: function () {
      window.addEventListener("keyup", e => {
        if (this.modalAsset) {
          if (e.key === 'ArrowLeft') {
            this.modalPrevAsset()
          } else if (e.key === 'ArrowRight') {
            this.modalNextAsset()
          }
        }
      });

      document.querySelectorAll('[data-modal-asset-id]').forEach(el => {
        const _this = this;
        $(el).on('click', function (e) {
          const assetId = $(this).data('modal-asset-id');
          const asset = _this.assets.find(ast => ast.id === assetId)
          if (asset) _this.modalAsset = asset
        });
      });
    },

    computed: {
      isVideo() {
        return this.modalAsset && this.modalAsset.asset_type === "Video"
      },

      modalAssetName: function () {
        if (this.modalAsset) return this.modalAsset.name;
        return null;
      },

      modalAssetUrl: function () {
        if (this.modalAsset) {
          return this.modalAsset.watermark_medium_url || this.modalAsset.thumb_url;
        }
        return null;
      },

      modalAssetCategories: function () {
        if (this.modalAsset) {
          if (this.modalAsset.categories) {
            return this.modalAsset.categories.slice(0, 3).map(e => e.name)
          }
        }
        return [];
      },

      modalAssetTags: function () {
        if (this.modalAsset) {
          const tags = this.modalAsset.tags || [];
          if (this.tagCategoryPriority) {
            return tags.slice().sort((t1, t2) => {
              const index1 = this.tagCategoryPriority.indexOf(t1.tag_category.name);
              const index2 = this.tagCategoryPriority.indexOf(t2.tag_category.name);
              return ((index1 > -1 ? index1 : Infinity) - (index2 > -1 ? index2 : Infinity));
            }).slice(0, 5).map(e => e.name);
          } else {
            return tags.slice(0, 5).map(e => e.name)
          }
        }
        return [];
      }
    },

    methods: {
      modalPrevAsset: function () {
        const indexOfCurrentAsset = this.assets.indexOf(this.modalAsset);
        if (indexOfCurrentAsset > 0) {
          this.modalAsset = this.assets[indexOfCurrentAsset - 1]
        }
      },

      modalNextAsset: function () {
        const indexOfCurrentAsset = this.assets.indexOf(this.modalAsset);
        if (indexOfCurrentAsset >= 0 && indexOfCurrentAsset < this.assets.length - 1) {
          this.modalAsset = this.assets[indexOfCurrentAsset + 1]
        }
      },

      backgroundImage: function (asset) {
        return `background-image: url(${asset.thumb_url})`
      },

      handleAssetClick: function (asset) {
        this.modalAsset = asset;
      }
    },

    mixins: [generalMixins],
    components: {VideoPlayer}
  }
</script>